export const styles = {
  h1: {
    fontSize: 24,
    fontFamily: "Raleway",
    color: "#0a3949",
    fontWeight: 700,
  },
  button: {
    margin: "15px 0 0 0",
    color: "#fff",
    padding: "12px 25px",
  },
  p: {
    fontFamily: "Raleway",
    width: "100%",
    float: "left",
    margin: "0 0 20px 0",
    padding: 0,
    fontSize: 16,
    color: "#8290a2",
    fontWeight: 500,
  },
};
